export default {
  'depth-1': '0px 2px 6px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(0, 0, 0, 0.04)',
  'depth-2': '0px 2px 6px rgba(0, 0, 0, 0.08), 0px 2px 1px rgba(0, 0, 0, 0.06)',
  'depth-3': '0px 2px 12px rgba(0, 0, 0, 0.12), 0px 2px 1px rgba(0, 0, 0, 0.1)',
  'page-header-bottom': '0px 1px 0px #E0E0E0',
  'page-footer-top':
    '0px -1px 1px rgba(0, 0, 0, 0.04), 0px -2px 6px rgba(0, 0, 0, 0.05)',
};
